export default __webpack_public_path__ + "static/media/TynkerJr.3c427a50.png";